// Copyright 2022 Ernesto Giron E.
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.​

import logo from './logo_Fundacion.png';
import React from 'react';
import './App.css';
import { Route, BrowserRouter as Router, Link, Switch } from "react-router-dom";

import styled from "styled-components";

// Encuestas
import Intro from './components/encuestas/Intro';
import Perfil from './components/encuestas/Perfil';
import EditarPerfil from './components/encuestas/EditarPerfil';
import Perfil2 from './components/encuestas/Perfil2';
import Perfil3 from './components/encuestas/Perfil3';
import Perfil4 from './components/encuestas/Perfil4';
import Familiares from './components/encuestas/Familiares';
import ListaFamiliares from './components/encuestas/ListaFamiliares';
import EditarFamiliares from './components/encuestas/EditarFamiliares';
import ListarEmpleados from './components/encuestas/ListarEmpleados';
import FinEncuesta from './components/encuestas/FinEncuesta';

const Logo = styled.img`
  width: auto;
  height: 55px;
  margin-right: 1em;
  margin-left: 20px;
  text-align:left;
  display: inline-flex;
`;

const AppName = styled.div`
  width: 240px;
  position: relative;
  display: inline-flex;
  padding: 0;
  text-align: center;
  font-size: 1.12em;
  font-weight: 600;
  letter-spacing: 0.5px;

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (max-width: 1200px) {
    width: 240px;
    font-size: 1.12em;
    font-weight: 600;
    letter-spacing: 0.5px;
  } 

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (max-width: 992px) {
    font-size: 1.2em;
    font-weight: 600;
    letter-spacing: 0.5px;
    width: 210px;
    line-height: 20px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (max-width: 768px) {
    // display: none;
    font-size: 1.2em;
    line-height: 20px;
    font-weight: 600;
    width: 240px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (max-width: 600px) {
    font-size: 1.2em;
    font-weight: 600;
    line-height: 15px;
    width: 240px;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    font-size: 1.2em;
    font-weight: 600;
    line-height: 22px;
    width: 240px;
  }

  /* Extra small devices (phones, 400px and down) */
  @media only screen and (max-width: 400px) {
    font-size: 1.0em;
    font-weight: 600;
    line-height: 20px;
    width: 200px;
  }

`;

const MainContainer = styled.div`
  margin-top:0px;
  max-width: 375px;
  background-color: #fff !important; //#f1f9f9;
  margin-left: auto;
  margin-right: auto;
  border: none;
  text-align: left;
  padding:2px;
`;

const Footer = () => {
  return(
  <div className="contact">
    Santiago de Cali, Colombia<br/>
    <strong>Dirección:</strong>Carrera 127 Parcelación Alférez Real Pance<br/>
    <strong>Teléfono</strong>: +57 (2) 519 0555 Ext. 384, 385, 390<br/>
    <a href="http://fundacionclubfarallones.org/" target="_new" id="hosting" rel="hosting">fundacionclubfarallones.org</a>
  </div>
  )
};

// Component definition
// const App = (props) => {
function App() {
  return (
    // <Router basename='~ernesto/FunFarallones/encuestas/encuesta1/'>
    <Router basename='/encuestas/encuesta1/'>
      <MainContainer>
        <nav className="navbar navbar-expand navbar-light">
            <div className="nav navbar-nav">
              <div className='logo-app-name'>
                <Logo src={logo} width="50" alt="Logo"/>
                <Link className="nav-item nav-link active" to={"/"}>
                  <AppName>Actualización de datos Empleados Club Farallones</AppName>
                </Link>
              </div>
                
            </div>
        </nav>
        <div className="container2">
          <Switch>
            <Route exact path='/' component={Intro}></Route>
            <Route path='/empleados' component={ListarEmpleados}></Route>
            <Route path='/perfileditar/:claveapi' component={EditarPerfil}></Route>
            <Route path='/nuevoempleado/' component={Perfil}></Route>
            <Route path='/perfil/:docid' component={Perfil}></Route>
            <Route path='/perfil2/:claveapi' component={Perfil2}></Route>
            <Route path='/perfil3/:claveapi' component={Perfil3}></Route>
            <Route path='/perfil4/:claveapi' component={Perfil4}></Route>
            <Route path='/familiares/:claveapi_docId' component={ListaFamiliares}></Route>
            <Route path='/addfamiliares/:claveapi_docId' component={Familiares}></Route>
            <Route path='/editarfamiliar/:id' component={EditarFamiliares}></Route>
            <Route path='/fin' component={FinEncuesta}></Route>
          </Switch> 
        </div>
        <Footer />
      </MainContainer>
    </Router>
  );
}

export default App;
